import { first } from 'monaco-editor/esm/vs/base/common/async.js';
import { Disposable, toDisposable } from 'monaco-editor/esm/vs/base/common/lifecycle.js';

class AbstractURLService extends Disposable {
    constructor() {
        super(...arguments);
        this.handlers = ( new Set());
    }
    open(uri, options) {
        const handlers = [...( this.handlers.values())];
        return first(( handlers.map(h => () => h.handleURL(uri, options))), undefined, false).then(val => val || false);
    }
    registerHandler(handler) {
        this.handlers.add(handler);
        return toDisposable(() => this.handlers.delete(handler));
    }
}

export { AbstractURLService };
